import { Repository } from './Repository';

export default class UserRepository extends Repository {
    constructor() {
        super();

        this.userRequestPrefix = '/api/v1/user';
    }

    getUsers = (url) => {
        return this.getRequestPromise('get', this.userRequestPrefix + `/${url}`);
    };

    checkUserId = (id) => {
        return this.getRequestPromise('get', this.userRequestPrefix + `/check/id?id=${id}`);
    };

    addUser = (url, param) => {
        return this.getRequestPromise('post', this.userRequestPrefix + `/${url}`, param);
    }

    addUsers = (url, param) => {
        return this.getRequestPromise('post', this.userRequestPrefix + `/${url}`, param);
    }

    updateUser = (userId, param) => {
        return this.getRequestPromise('put', this.userRequestPrefix + `/${userId}`, param);
    }

    getLocaleAdminUserIds = (localeCode) => {
        return this.getRequestPromise('get', this.userRequestPrefix + `/list/id/locale-admin?localeCode=${localeCode}`);
    }

    getLocaleGroups = (localeAdminUserId) => {
        return this.getRequestPromise('get', this.userRequestPrefix + `/list/locale-group?localeAdminUserId=${localeAdminUserId}`);
    }

    getLocaleGroup = (groupAdminUserId) => {
        return this.getRequestPromise('get', this.userRequestPrefix + `/locale-group?groupAdminUserId=${groupAdminUserId}`);
    }

    getLocaleGroupConfigs = (localeGroupId) => {
        return this.getRequestPromise('get', this.userRequestPrefix + `/locale-group/${localeGroupId}/config`);
    }

    getUser = (userId) => {
        return this.getRequestPromise('get', this.userRequestPrefix + `/${userId}`);
    }

    getUserProfile = (userId) => {
        return this.getRequestPromise('get', this.userRequestPrefix + `/${userId}/profile`);
    }

    updateUserProfile = (userId, param) => {
        return this.getRequestPromise('put', this.userRequestPrefix + `/${userId}/profile`, param);
    }


}
